// extracted by mini-css-extract-plugin
export default {"popup":"DrawCursorPopup_popup__lQbyx"};